import React from 'react'
import { FlexGrid, Box, Typography } from '@telus-uds/components-web'

export type IPlanSection = {
  headingIcon?: JSX.Element
  headingText?: string
  tooltipText?: string
  descriptionText?: string
  images?: React.ReactNode
  textLink?: JSX.Element
}

export type StickyCartPlanProps = {
  stickyCardsHeading?: string
  planCardSection?: React.ReactNode
}

const StickyCartPlan = ({ stickyCardsHeading, planCardSection }: StickyCartPlanProps) => (
  <>
    <FlexGrid.Col>
      <Box vertical={2} horizontal={3}>
        <Typography block variant={{ size: 'h2' }} heading="h2">
          {stickyCardsHeading}
        </Typography>
      </Box>
    </FlexGrid.Col>
    <FlexGrid.Row>
      <FlexGrid.Col>
        <div style={{ paddingLeft: '16px', paddingRight: '16px' }} data-testid={'planSection-id'}>
          {planCardSection}
        </div>
      </FlexGrid.Col>
    </FlexGrid.Row>
  </>
)

export default StickyCartPlan
